import * as React from "react";
import type { SchedulesPublicEventResponse } from "src/types";

import useEvent from "@/hooks/use-event";
import endpoints from "@/utils/endpoints";
import { fetchJSON } from "@/utils/fetchJSON";
import { isError } from "@/utils/is-error";

const get = endpoints();

/**
 * Custom hook that fetches venue_type for the current event.
 * Only makes the API call once per event slug.
 */
export function useVenueType() {
  const { event, setEvent } = useEvent();

  React.useEffect(() => {
    const fetchVenueType = async () => {
      if (!event?.slug || event.venue_type) {
        return;
      }

      try {
        const response = await fetchJSON<SchedulesPublicEventResponse>(
          get("SCHEDULES_PUBLIC_EVENT_API")(event.slug)
        );

        if (!isError(response) && response.event?.venue_type) {
          setEvent((prevEvent) => ({
            ...prevEvent,
            venue_type: response.event.venue_type,
          }));
        }
      } catch (error) {
        // Silently fail - venue_type is optional
        console.warn("Failed to fetch venue_type:", error);
      }
    };

    fetchVenueType();
  }, [event?.slug, event?.venue_type]);

  return {
    venue_type: event?.venue_type,
  };
}
